export default function MobileCallButton() {
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3 lg:hidden">
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-[#FF6B35]/40 animate-ping" style={{ animationDuration: '2s' }} />
        <a href="tel:+18605550127"
          className="relative flex items-center gap-2.5 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-black pl-4 pr-5 py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer"
          aria-label="Call DBN Garage South Windsor CT auto protection"
          style={{ boxShadow: '0 8px 25px rgba(255,107,53,0.45)' }}>
          <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-base" /></span>
          <span className="text-sm">(860) 555-0127</span>
        </a>
      </div>
      <a href="#lead-form"
        className="flex items-center gap-2 bg-[#111111] border border-white/20 hover:border-white/40 text-white font-bold pl-4 pr-5 py-2.5 rounded-full transition-colors whitespace-nowrap cursor-pointer text-xs">
        <span className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-check-fill text-[#FF6B35] text-xs" /></span>
        Book Free Consultation
      </a>
    </div>
  );
}
